import styled from "@emotion/native"
import ArrowBackIcon from "../assets/v2/BackArrow.svg"
import { useNavigation } from "@react-navigation/native"

type BackArrowProps = {
  onPress?: () => void
  backgroundColor?: string
  arrowColor?: string
}

export function BackArrowV2(props: BackArrowProps) {
  const { onPress, backgroundColor, arrowColor = "#1F1C22" } = props

  const navigation = useNavigation()

  const handleBackPress = () => {
    if (onPress) {
      onPress()
      return
    }

    navigation.goBack()
  }

  return (
    <ArrowContainer
      testID="onboardingBackButton"
      accessibilityLabel="Back"
      onPress={handleBackPress}
      backgroundColor={backgroundColor}
    >
      <ArrowBackIcon color={arrowColor} />
    </ArrowContainer>
  )
}

const ArrowContainer = styled.Pressable<{ backgroundColor?: string }>`
  padding: 12px 16px;
  border-radius: 100px;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.backArrow.background};
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
`
